<template>
  <ol
    :aria-label="props.ariaLabel"
    class="c-progress-steps tw:m-0 tw:list-none tw:p-0"
    :class="{ 'column full-width': stacked }"
    role="list"
  >
    <slot />
  </ol>
</template>

<script setup lang="ts">
import { provide } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import {
  ProgressStepCurrentSymbol,
  ProgressStepSelectSymbol,
} from "shared/components/base/symbols";

interface ProgressStepsProps {
  ariaLabel?: string;
  modelValue: number;
  stacked?: boolean;
}

interface ProgressStepsEmits {
  "update:modelValue": [value: number];
}

const props = withDefaults(defineProps<ProgressStepsProps>(), {
  ariaLabel: () => getLocaleText("progress_steps.label"),
});

const emit = defineEmits<ProgressStepsEmits>();

const selectStep = ({ step }: { step: number }) => {
  emit("update:modelValue", step);
};

provide(ProgressStepCurrentSymbol, () => props.modelValue);
provide(ProgressStepSelectSymbol, selectStep);
</script>

<style lang="scss" scoped>
.c-progress-steps {
  display: flex;
  gap: 1px;

  > * {
    flex: 1;
  }
}
</style>
